/**
 * Keeps the breadcrumb trail on a single line.
 *
 * The list scrolls horizontally with the scrollbar hidden, so the only hint
 * that there is more to see is a soft mask fade. This toggles the classes that
 * drive that fade, so an edge only fades while content is actually hidden
 * behind it. Styling lives in theme.css.
 */
(function () {
  var SELECTOR = '.breadcrumb__list';
  var THRESHOLD = 2;

  function update(list) {
    var overflow = list.scrollWidth - list.clientWidth;
    var scrollable = overflow > THRESHOLD;

    list.classList.toggle('is-scrollable', scrollable);

    if (!scrollable) {
      list.classList.remove('is-at-start');
      list.classList.remove('is-at-end');
      return;
    }

    var position = Math.abs(list.scrollLeft);

    list.classList.toggle('is-at-start', position <= THRESHOLD);
    list.classList.toggle('is-at-end', position >= overflow - THRESHOLD);
  }

  function observe(list) {
    if (list.dataset.hpBreadcrumbScroll === 'true') return;
    list.dataset.hpBreadcrumbScroll = 'true';

    list.addEventListener(
      'scroll',
      function () {
        update(list);
      },
      { passive: true }
    );

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () {
        update(list);
      }).observe(list);
    } else {
      window.addEventListener('resize', function () {
        update(list);
      });
    }

    update(list);
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Fonts landing late change the measured width, and the editor swaps sections in.
  window.addEventListener('load', function () {
    init();
    document.querySelectorAll(SELECTOR).forEach(update);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
